// extracted by mini-css-extract-plugin
export default {"action":"navbar-action_action__6Jt83","centered":"navbar-action_centered__SOs52","actionText":"navbar-action_actionText__I15Pg"};